import { render, staticRenderFns } from "./MoleculeAttachmentList.vue?vue&type=template&id=08067820&scoped=true&"
import script from "./MoleculeAttachmentList.vue?vue&type=script&lang=js&"
export * from "./MoleculeAttachmentList.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeAttachmentList.vue?vue&type=style&index=0&id=08067820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08067820",
  null
  
)

export default component.exports